export const pathGenerate = (
  basepath: string,
  staticBasepath: string,
  isLocal: boolean,
  path: string
) => {
  if (isLocal) {
    return `${staticBasepath}${path}`;
  }

  return `${basepath}${path}`;
};
